module.exports = "/images/MA.png?2ae12eedb9c396be798da13de4c3b5ab";